import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ["transactionDate", "amount", "description"]

    connect() {

    }

    syncTransactionDate(event) {
        const currentRow = this.element
        let nextRow = currentRow.nextElementSibling

        while (nextRow) {
            const transactionDateField = nextRow.querySelector('input[name*="transaction_date"]')
            if (transactionDateField) {
                transactionDateField.value = event.target.value
                transactionDateField.dispatchEvent(new Event('change', {bubbles: true}))
            }
            nextRow = nextRow.nextElementSibling
        }
    }

    syncAmount(event) {
        const currentRow = this.element
        let nextRow = currentRow.nextElementSibling

        while (nextRow) {
            const amountField = nextRow.querySelector('input[name*="amount"]')
            if (amountField) {
                amountField.value = event.target.value
                amountField.dispatchEvent(new Event('change', {bubbles: true}))
            }
            nextRow = nextRow.nextElementSibling
        }
    }

    syncDescription(event) {
        const currentRow = this.element
        let nextRow = currentRow.nextElementSibling

        while (nextRow) {
            const descriptionField = nextRow.querySelector('input[name*="description"]')
            if (descriptionField && descriptionField.value.trim() === '') {
                descriptionField.value = event.target.value
                descriptionField.dispatchEvent(new Event('change', {bubbles: true}))
            }
            nextRow = nextRow.nextElementSibling
        }
    }
}